import TaskDetails from "./taskDetailsContainer";
export default TaskDetails;